/** Session / UI phase while creating an action item from voice, selection, or typed text. */
export const CREATE_STATUS_PHASE_CREATING = "creating";
export const CREATE_STATUS_PHASE_SUCCESS = "success";
export const CREATE_STATUS_PHASE_ERROR = "error";
